import { z } from "zod";

import { productSchema } from "./productSchema";

const introOfferSchema = z.object({
  amount: z.number(),
  locale: z.string(),
});

const promoCodeOptionSchema = z.object({
  name: z.string(),
  variables: z.any(),
});

export type PromoCodeOption = z.infer<typeof promoCodeOptionSchema>;

export const promoCodeSchema = z.object({
  id: z.number(),
  code: z.string(),
  group: z.string(),
  grants: z.array(promoCodeOptionSchema),
  rules: z.array(promoCodeOptionSchema),
});

export type PromoCode = z.infer<typeof promoCodeSchema>;

const cartErrorSchema = z.object({
  status: z.string(),
  error: z.string(),
  code: z.number(),
});

const taxSchema = z.object({
  name: z.string(),
  juris_name: z.string(),
  amount: z.number(),
});

export type Tax = z.infer<typeof taxSchema>;

const redirectPaymentMethods = z.enum(["gcash"]);

const paymentPlatforms = z.enum(["stripe", "paypal", "hallow", "hotmart"]);

const paymentMethods = z.union([redirectPaymentMethods, paymentPlatforms]);

export type PaymentMethod = z.infer<typeof paymentMethods>;

export const cartSchema = z.object({
  country: z.string(),
  currency: z.string(),
  discount: z.number(),
  errors: z.array(cartErrorSchema),
  intro_offer: introOfferSchema.nullable(),
  is_renewing: z.boolean(),
  needs_postal_code: z.boolean(),
  payment_required: z.boolean(),
  pretax_total: z.number(),
  product: productSchema,
  promo_code: promoCodeSchema.nullable(),
  renewal_discount: z.number(),
  renewal_pretax_total: z.number(),
  renewal_tax: z.number(),
  renewal_taxes: taxSchema.array(),
  renewal_total: z.number(),
  subtotal: z.number(),
  supported_platforms: z.array(paymentPlatforms),
  supported_redirect_payment_methods: z.array(redirectPaymentMethods),
  tax: z.number(),
  taxes: taxSchema.array(),
  total: z.number(),
  trial_end_date: z.iso.datetime(),
});

export type Cart = z.infer<typeof cartSchema>;

type PaymentAddress = {
  city?: string;
  line1?: string;
  line2?: string;
  postal_code?: string;
  state?: string;
  country?: string;
  metadata?: any;
};

export type PaymentResult = {
  paymentMethod: string | null;
  paymentPlatform?: "stripe" | "paypal";
  name?: string;
  email?: string;
  address?: PaymentAddress;
};

export type PaymentRedirect = {
  paymentMethod: string;
  name?: string;
  email?: string;
  phone?: string;
  document?: string;
};
